import { floorNumber, formatDollars } from '@kwenta/sdk/utils'
import { ChangeEvent, FC, memo, useCallback } from 'react'
import styled from 'styled-components'

import { FlexDivCol, FlexDivRow } from 'components/layout/flex'
import StyledSlider from 'components/Slider/StyledSlider'
import { editTradeSizeInput } from 'state/futures/actions'
import { selectCrossMarginTradeInputs } from 'state/futures/crossMargin/selectors'
import { selectMaxUsdSizeInput, selectTradeSizeInputsDisabled } from 'state/futures/selectors'
import { useAppDispatch, useAppSelector } from 'state/hooks'

const TradeSizeSlider: FC = memo(() => {
	const dispatch = useAppDispatch()
	const maxUsdSize = useAppSelector(selectMaxUsdSizeInput)
	const isDisabled = useAppSelector(selectTradeSizeInputsDisabled)
	const { susdSizeString } = useAppSelector(selectCrossMarginTradeInputs)

	const onChangeValue = useCallback(
		(_: ChangeEvent<any>, newSize: number | number[]) => {
			if (typeof newSize === 'number') {
				const floored = floorNumber(Number(newSize), 4)
				dispatch(editTradeSizeInput(String(floored), 'usd'))
			}
		},
		[dispatch]
	)

	return (
		<Container>
			<SliderRow>
				<StyledSlider
					minValue={0}
					maxValue={maxUsdSize.toNumber() ?? 0}
					step={0.1}
					value={Number(susdSizeString)}
					onChange={onChangeValue}
					disabled={isDisabled}
					marks={
						maxUsdSize.toNumber() > 0
							? [
									{ value: 0, label: `0` },
									{
										value: maxUsdSize.toNumber(),
										label: maxUsdSize.gt(0) ? 'Max' : '',
									},
							  ]
							: []
					}
					$currentMark={Number(susdSizeString || 0)}
					valueLabelFormat={(v: number) => formatDollars(v)}
				/>
			</SliderRow>
		</Container>
	)
})

const Container = styled(FlexDivCol)`
	margin-bottom: 24px;
`

const SliderRow = styled(FlexDivRow)`
	margin-top: 8px;
	margin-bottom: 14px;
	position: relative;
`

export default TradeSizeSlider
